import { render, staticRenderFns } from "./FieldItem.vue?vue&type=template&id=36097a60&scoped=true&"
import script from "./FieldItem.vue?vue&type=script&lang=js&"
export * from "./FieldItem.vue?vue&type=script&lang=js&"
import style0 from "./FieldItem.vue?vue&type=style&index=0&id=36097a60&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36097a60",
  null
  
)

export default component.exports